import React from 'react';
import PropTypes from 'prop-types';

const ModalHeader = ({ close, title, subtitle }) => (
    <div className="modal-header clearfix text-left">
        { close && (
            <button type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={close}
            >
                <i className="pg-close fs-14" />
            </button>
        )}
        { title && (
            <h5>{title}</h5>
        )}
        { subtitle && (
            <p className="p-b-10">{subtitle}</p>
        )}
    </div>
);

ModalHeader.propTypes = {
    close: PropTypes.func,
    title: PropTypes.node,
    subtitle: PropTypes.node,
};

export default ModalHeader;


// WEBPACK FOOTER //
// ./src/components/base/secure/modals/modal-header.js